<template>
    <div class="py-6 px-10 w-full lg:h-screen overflow-hidden">
        <goals
            :token="queryParam.token"
        ></goals>
    </div>
</template>
<script>
    import Goals from './Goals.vue';

    export default {
        components: {
            Goals
        },
        computed: {
            queryParam() {
                return {
                    token: this.$route.query.token
                }
            }
        }
    }
</script>